export default "__VITE_ASSET__e28822a9__"